var React = require('react');

function X3 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.428743 2.0869L1.77939 0.760366L19.0001 17.6736L17.6495 19.0001L0.428743 2.0869Z","fill":"#E4E4E4","key":0}),React.createElement("path",{"d":"M17.6495 0.428711L19.0001 1.75524L1.77936 18.6685L0.428711 17.342L17.6495 0.428711Z","fill":"#E4E4E4","key":1})]);
}

X3.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = X3;

X3.default = X3;
